<video #videoPlayer id="background-video-tutorial" crossorigin="anonymous" class="video-js vjs-default-skin"></video>
